import { render, staticRenderFns } from "./AscFooter.vue?vue&type=template&id=4bd0d1e8&"
import script from "./AscFooter.vue?vue&type=script&lang=js&"
export * from "./AscFooter.vue?vue&type=script&lang=js&"
import style0 from "./AscFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VContainer,VDivider,VFooter})
